import { render, staticRenderFns } from "./PixelModal.vue?vue&type=template&id=591b1171&scoped=true&"
import script from "./PixelModal.vue?vue&type=script&lang=js&"
export * from "./PixelModal.vue?vue&type=script&lang=js&"
import style0 from "./PixelModal.vue?vue&type=style&index=0&id=591b1171&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591b1171",
  null
  
)

export default component.exports